/*
  Ebbrest: движение текста, пара к eb-motion.css. Без библиотек, с defer. Полное описание: sections/eb-marquee.liquid.
  data-eb-rise ("lines"), data-eb-swap="a|b|c", data-eb-drift ("y"), data-eb-marquee ("flow", "scroll"), data-eb-pick. Без правки секций:
  window.ebMotion = { rise: { 'селектор': 'lines' } }. Что на экране при загрузке, не анимируется. EBMotion.init(узел).
  Один requestAnimationFrame на всё: кадр заказывает прокрутка, а пока на экране есть строка, которую ведёт скрипт и которая не на паузе, кадр заказывает себя сам.
*/
(function () {
  var W = window, d = document;
  if (W.__ebMotion || !('IntersectionObserver' in W)) return;
  W.__ebMotion = true;

  var mq = W.matchMedia('(prefers-reduced-motion: reduce)');
  var drifts = [], pending = [], mqs = [], queued = false, last = 0, lastW = W.innerWidth;
  var hover = W.matchMedia('(hover:hover)');

  function reduced() { return mq.matches; }
  function all(sel, host) { return [].slice.call((host && host.querySelectorAll ? host : d).querySelectorAll(sel)); }
  function once(el, key) { return el[key] ? false : (el[key] = true); }
  function onScreen(el) { var r = el.getBoundingClientRect(); return r.top < W.innerHeight && r.bottom > 0; }
  function tone(w) { return /cool|cold/i.test(w) ? ' eb-accent--cool' : /warm/i.test(w) ? ' eb-accent--warm' : ''; }
  function el(cls) { var s = d.createElement('span'); s.className = cls; return s; }

  /* вне экрана ничего не крутится */
  var vis = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.__ebVis.forEach(function (fn) { fn(e.isIntersecting); }); });
  }, { rootMargin: '10% 0px' });
  function watch(node, fn) { (node.__ebVis = node.__ebVis || []).push(fn); vis.observe(node); }
  /* строкам поле не нужно: полоса фактов лежит сразу под первым экраном и с полем считалась бы видимой, пока человек стоит наверху */
  var visMq = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.target.__ebMqVis) e.target.__ebMqVis(e.isIntersecting); });
  }, { rootMargin: '-2px 0px' }); /* верх полосы стоит на долю пикселя выше низа экрана */

  /* 2. Слово: текст до пробела вместе с прилипшими тегами, точка после курсива не уедет на новую строку */
  function split(h) {
    var frag = d.createDocumentFragment(), cur = null, n = 0;
    function word() {
      if (!cur) { cur = el('eb-w'); cur.style.setProperty('--eb-i', n++); frag.appendChild(cur); }
      return cur;
    }
    if (!h.hasAttribute('aria-label')) { /* диктору заголовок целиком */
      var copy = h.cloneNode(true);
      all('[aria-hidden="true"]', copy).forEach(function (x) { x.parentNode.removeChild(x); });
      h.setAttribute('aria-label', copy.textContent.replace(/\s+/g, ' ').trim());
    }
    [].slice.call(h.childNodes).forEach(function (c) {
      if (c.nodeType === 3) {
        c.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { cur = null; frag.appendChild(d.createTextNode(' ')); }
          else word().appendChild(d.createTextNode(part));
        });
      } else if (c.tagName === 'BR') { cur = null; frag.appendChild(c); }
      else if (c.nodeType === 1) word().appendChild(c);
    });
    h.textContent = '';
    h.appendChild(frag);
  }

  var riseIo = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var h = e.target, top = null, i = -1;
      if (!e.isIntersecting) return;
      riseIo.unobserve(h);
      if (h.getAttribute('data-eb-rise') === 'lines') all('.eb-w', h).forEach(function (w) {
        if (w.offsetTop !== top) { top = w.offsetTop; i++; }
        w.style.setProperty('--eb-i', i);
      });
      h.classList.add('is-in');
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });

  function rise(host) {
    all('[data-eb-rise]', host).forEach(function (h) {
      if (!once(h, '__ebRise') || reduced() || onScreen(h)) return;
      split(h);
      h.classList.add('eb-rise');
      riseIo.observe(h);
      pending.push(h);
    });
  }

  /* 4. Смена слова */
  function swap(host) {
    all('[data-eb-swap]', host).forEach(function (node) {
      var words = node.getAttribute('data-eb-swap').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!once(node, '__ebSwap') || words.length < 2 || reduced()) return;
      var sr = el('eb-vh'), box = el('eb-swap__box'), i = 0, timer = 0;
      sr.textContent = node.textContent;
      box.setAttribute('aria-hidden', 'true');
      var items = words.map(function (w, k) {
        var s = el('eb-swap__w eb-accent' + tone(w) + (k ? '' : ' is-active'));
        s.textContent = w;
        return box.appendChild(s);
      });
      node.textContent = '';
      node.appendChild(sr);
      node.appendChild(box);
      node.setAttribute('aria-live', 'off');
      function step() {
        if (reduced() || d.hidden) return;
        items.forEach(function (s) { s.classList.remove('is-out'); });
        items[i].classList.remove('is-active');
        items[i].classList.add('is-out');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }
      watch(node, function (on) {
        clearInterval(timer);
        if (on) timer = setInterval(step, +node.getAttribute('data-eb-swap-ms') || 2400);
      });
    });
  }

  /* 5. Сдвиг: проход родителя через экран, от -1 до 1 */
  function frame(ts) {
    queued = false;
    var dt = last ? Math.min((ts - last) / 1000, .05) : 0;
    last = ts;
    /* наблюдатель молчит, если заголовок проскочил экран целиком (переход по якорю): пролистанное показываем без перехода */
    pending = pending.filter(function (h) {
      if (h.classList.contains('is-in')) return false;
      if (h.getBoundingClientRect().bottom > 0) return true;
      riseIo.unobserve(h);
      h.classList.add('is-in', 'is-now');
      return false;
    });
    var off = reduced(), vh = W.innerHeight, live = false;
    /* редактор темы перерисовал секцию: записи оторванных узлов выбрасываются, иначе кадры не остановятся */
    mqs = mqs.filter(function (it) { return it.el.isConnected !== false; });
    drifts = drifts.filter(function (it) { return it.el.isConnected !== false; });
    /* сначала все замеры, потом все записи */
    mqs.forEach(function (it) {
      if (off || !it.on) { it.top = null; return; }
      if (it.dirty) measure(it);
      it.now = it.el.getBoundingClientRect().top;
    });
    mqs.forEach(function (it) {
      if (off) { if (it.js) { it.js = false; it.el.classList.remove('is-js'); it.view.style.transform = ''; } return; }
      if (!it.on || !it.w) return;
      if (!it.js) { it.js = true; it.el.classList.add('is-js'); }
      var stop = it.hover || it.el.classList.contains('is-paused'), x;
      /* на паузе кадр заказывает только прокрутка или снятие паузы */
      if (!stop) live = true;
      if (it.scroll) {
        /* 7. От прокрутки: сдвиг равен доле it.k пути секции по экрану (от половины до целого, см. measure),
           плюс медленный собственный ход (его и останавливает пауза) */
        if (!stop) it.x += dt * Math.max(10, it.vw * .012);
        x = it.x - it.now * it.k;
      } else {
        /* 6. Сама и быстрее при прокрутке: добавка от скорости набирается быстро, спадает за полсекунды; направление одно */
        var v = it.top == null || !dt ? 0 : Math.min(Math.abs(it.now - it.top) / dt * .55, 1600);
        it.extra += (v - it.extra) * (v > it.extra ? .3 : 1 - Math.exp(-dt / .45));
        if (!stop) it.x += dt * (it.w / it.dur + it.extra);
        x = it.x;
      }
      it.top = it.now;
      x = ((x % it.w) + it.w) % it.w;
      it.view.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
      if (it.scroll) {
        /* подсветка стоит на фразе и на её копии во второй группе: на стыке круга в центр въезжает узел, у которого класс уже есть */
        var best = -1, bd = 1e9, n = it.n;
        it.mid.forEach(function (c, i) { var q = Math.abs(c - x - it.vw / 2); if (q < bd) { bd = q; best = i % n; } });
        if (best !== it.near) {
          it.items.forEach(function (node, i) { node.classList.toggle('is-near', i % n === best); });
          it.near = best;
        }
      }
    });
    if (!off) drifts.forEach(function (it) {
      if (!it.on) return;
      var r = it.el.parentNode.getBoundingClientRect(), p = (vh - r.top) / (vh + r.height);
      it.el.style.setProperty('--eb-dp', ((p < 0 ? 0 : p > 1 ? 1 : p) * 2 - 1).toFixed(3));
    });
    if (live) schedule(); else last = 0;
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(frame); } }

  /* ширина одного круга (группа и зазор) и середины фраз; пересчёт после смены ширины окна и догрузки шрифта */
  function measure(it) {
    it.dirty = false;
    it.vw = it.el.clientWidth;
    it.w = it.group.offsetWidth + (parseFloat(getComputedStyle(it.view).columnGap) || 0);
    it.dur = (+it.el.getAttribute('data-eb-mq-dur') || 30) * (W.innerWidth >= 990 ? 1.5 : 1);
    it.mid = it.items.map(function (n) { return n.offsetLeft + n.offsetWidth / 2; });
    it.n = it.group.querySelectorAll('.eb-mq__item').length || it.items.length;
    /* доля пути: за проход секции через экран строка проходит до целого круга, чтобы у центра побывали все фразы;
       не меньше половины и не больше единицы (быстрее прокрутки строка не едет) */
    it.k = Math.min(1, Math.max(.5, it.w / (W.innerHeight + it.el.offsetHeight)));
  }
  function dirty() { mqs.forEach(function (it) { it.dirty = true; }); schedule(); }
  /* на телефоне resize приходит с каждым уходом адресной строки: перемер только при смене ширины */
  function resized() { if (W.innerWidth === lastW) return; lastW = W.innerWidth; dirty(); }

  function drift(host) {
    all('[data-eb-drift]', host).forEach(function (node) {
      if (!once(node, '__ebDrift') || reduced() || onScreen(node)) return;
      var it = { el: node, on: false };
      drifts.push(it);
      watch(node, function (on) { it.on = on; schedule(); });
    });
  }

  /* 1. Бегущая строка едет на CSS, здесь пауза. С режимом "flow" или "scroll" строку ведёт кадр выше */
  function marquee(host) {
    all('[data-eb-marquee]', host).forEach(function (node) {
      if (!once(node, '__ebMq')) return;
      var b = node.querySelector('[data-eb-mq-pause]'), mode = node.getAttribute('data-eb-marquee');
      var view = node.querySelector('.eb-mq__view'), group = node.querySelector('.eb-mq__group'), it = null;
      if ((mode === 'flow' || mode === 'scroll') && view && group) {
        it = { el: node, view: view, group: group, items: all('.eb-mq__item', node), scroll: mode === 'scroll',
          x: 0, extra: 0, top: null, near: -1, n: 1, k: .5, dirty: true, on: false, js: false, hover: false };
        mqs.push(it);
        node.addEventListener('mouseenter', function () { it.hover = hover.matches; });
        node.addEventListener('mouseleave', function () { it.hover = false; schedule(); });
      }
      node.__ebMqVis = function (on) { node.classList.toggle('is-off', !on); if (it) { it.on = on; schedule(); } };
      visMq.observe(node);
      /* курсив: файл начертания 94 КБ. Слова становятся курсивными за полтора экрана до строки, тогда браузер его и качает */
      var net = navigator.connection;
      if (node.hasAttribute('data-eb-italic') && !(net && net.saveData)) {
        var fio = new IntersectionObserver(function (es) {
          if (!es.some(function (e) { return e.isIntersecting; })) return;
          fio.disconnect();
          node.classList.add('is-italic');
          dirty();
        }, { rootMargin: '150% 0px' });
        fio.observe(node);
      }
      /* касание по строке или по значку паузы: на телефоне нет ни наведения, ни Tab */
      node.addEventListener('click', function () {
        var p = node.classList.toggle('is-paused');
        if (b) b.setAttribute('aria-pressed', p);
        schedule();
      });
    });
  }

  /* 8. Список со сменой кадра (sections/eb-pick.liquid). Время ведёт CSS-анимация полоски: её конец переключает пункт,
     её пауза (наведение, секция вне экрана) держит и переключение. После нажатия, касания или фокуса внутри само больше не листает */
  function pick(host) {
    all('[data-eb-pick]', host).forEach(function (node) {
      if (!once(node, '__ebPick')) return;
      var items = all('[data-eb-pick-item]', node), frames = all('[data-eb-pick-frame]', node), cur = 0;
      var btns = items.map(function (n) { return n.querySelector('button'); });
      var bodies = all('.eb-pick__body', node);
      if (items.length < 2) return;
      /* сворачивание пунктов висит на этом классе, а не на eb-js из head: не загрузился этот файл, все пункты остаются раскрытыми */
      node.classList.add('is-ready');
      var pw = 0;
      function manual() { node.classList.add('is-manual'); }
      function show(i, user) {
        cur = i;
        items.forEach(function (n, k) { n.classList.toggle('is-active', k === i); });
        /* у пункта без кадра остаётся кадр прежнего */
        if (frames.some(function (n) { return +n.getAttribute('data-eb-pick-frame') === i; }))
          frames.forEach(function (n) { n.classList.toggle('is-active', +n.getAttribute('data-eb-pick-frame') === i); });
        if (user) manual();
        aria();
      }
      /* при «меньше движения» раскрыты все пункты: нажатие только меняет кадр */
      function aria() {
        btns.forEach(function (b, k) {
          b.setAttribute('aria-expanded', reduced() || k === cur);
          if (reduced() && k === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
      }
      /* текст пунктов разной длины: высота раскрытого равна самому длинному, блок ниже не прыгает */
      function size(e) {
        if (e && e.type === 'resize' && W.innerWidth === pw) return;
        pw = W.innerWidth;
        node.style.removeProperty('--eb-pick-h');
        var h = 0;
        bodies.forEach(function (n) { h = Math.max(h, n.offsetHeight); });
        if (h) node.style.setProperty('--eb-pick-h', h + 'px');
      }
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () { show(k, true); });
        b.addEventListener('keydown', function (e) {
          var to = e.key === 'ArrowDown' ? k + 1 : e.key === 'ArrowUp' ? k - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? btns.length - 1 : -1;
          if (to < 0 || to >= btns.length) return;
          e.preventDefault();
          btns[to].focus();
        });
      });
      node.addEventListener('animationend', function (e) {
        if (e.animationName === 'eb-pick-bar' && !node.classList.contains('is-manual')) show((cur + 1) % items.length);
      });
      node.addEventListener('mouseenter', function () { if (hover.matches) node.classList.add('is-hold'); });
      node.addEventListener('mouseleave', function () { node.classList.remove('is-hold'); });
      /* фокус внутри или касание секции останавливают самолистание насовсем: на телефоне нет наведения,
         а текст не должен закрываться под пальцем и под диктором */
      node.addEventListener('focusin', manual);
      node.addEventListener('touchstart', manual, { passive: true });
      node.addEventListener('pointerdown', manual);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { node.classList.toggle('is-away', !e.isIntersecting); });
      }, { threshold: .35 }).observe(node);
      node.classList.add('is-away');
      (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(aria);
      W.addEventListener('resize', size, { passive: true });
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { size(); });
      size();
      aria();
    });
  }

  function init(host) {
    var cfg = W.ebMotion || {};
    Object.keys(cfg).forEach(function (kind) {
      Object.keys(cfg[kind]).forEach(function (sel) {
        all(sel, host).forEach(function (node) {
          if (!node.hasAttribute('data-eb-' + kind)) node.setAttribute('data-eb-' + kind, cfg[kind][sel]);
        });
      });
    });
    swap(host); /* до rise */
    rise(host);
    drift(host);
    marquee(host);
    pick(host);
  }

  /* перехват: слышно и окно, и .page-wrapper Horizon */
  d.addEventListener('scroll', schedule, { passive: true, capture: true });
  W.addEventListener('resize', resized, { passive: true });
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(schedule);
  if (d.fonts && d.fonts.addEventListener) d.fonts.addEventListener('loadingdone', dirty);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });

  W.EBMotion = { init: init };
  init(d);
  schedule();
})();
